module.exports = __webpack_public_path__ + "img/3.1549d951.jpg";